module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_17-c3ca1aca1d4ee26764fb26913840bbc7.jpg";